export default __webpack_public_path__ + "static/media/NIAS0190.34I-29285_-16982_0.2957d20e.jpg";